import { memo } from 'react'
import { Avatar, Box, Card, Divider, Group, Stack, Text } from 'components'
import { useArcTranslation } from 'hooks'
import { getInitials } from 'helpers'
import type { ClassMiniCardProps } from '../interfaces'
import { MemberAvatarGroup } from './MemberAvatarGroup'

const cardStyle = { display: 'flex', flexDirection: 'column' as const, height: '100%' }

/** Compact class card: name, student count and teachers (per groups route contract). */
export const ClassMiniCard = memo(({ managerClass }: ClassMiniCardProps) => {
  const { t } = useArcTranslation()
  const hasStudents = managerClass.studentsCount > 0
  const hasTeachers = managerClass.teachers.length > 0

  return (
    <Card shadow='sm' withBorder radius='md' p={0} style={cardStyle}>
      <Group spacing='sm' p='md' noWrap>
        <Avatar size='lg' radius='xl' color='gray' alt={managerClass.name}>
          {getInitials(managerClass.name)}
        </Avatar>
        <Text size='lg' weight={700} lineClamp={1}>
          {managerClass.name}
        </Text>
      </Group>

      <Divider />

      <Stack spacing='md' p='md' style={{ flex: 1 }}>
        <Box>
          <Text size='xs' color='dimmed' tt='uppercase'>
            {t('manager_dashboard.students_label')}
          </Text>
          <Text size='sm'>
            {hasStudents
              ? t('manager_dashboard.students_count', { count: managerClass.studentsCount })
              : t('manager_dashboard.no_students')}
          </Text>
        </Box>

        {hasTeachers && (
          <MemberAvatarGroup members={managerClass.teachers} label={t('manager_dashboard.teachers_label')} />
        )}
      </Stack>
    </Card>
  )
})

ClassMiniCard.displayName = 'ClassMiniCard'
